import { render, staticRenderFns } from "./regulation.vue?vue&type=template&id=554b1fb0"
import script from "./regulation.vue?vue&type=script&lang=js"
export * from "./regulation.vue?vue&type=script&lang=js"
import style0 from "./regulation.vue?vue&type=style&index=0&id=554b1fb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports